import * as React from "react";
import type { SVGProps } from "react";

const getTheme = (theme) => {
  return theme === "dark" ? "#FFFFFF" : "#121214";
};
const SvgTwoColorInviteFriends = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill={getTheme(props["data-theme"])}
      fillRule="evenodd"
      d="M9.75 6a2.25 2.25 0 1 1 4.5 0 2.25 2.25 0 0 1-4.5 0ZM12 2.25a3.75 3.75 0 0 0-1.6 7.143C5.728 10.238 2.25 14.725 2.25 20a.75.75 0 0 0 1.5 0c0-5.185 3.766-9.25 8.25-9.25s8.25 4.065 8.25 9.25a.75.75 0 0 0 1.5 0c0-5.275-3.477-9.762-8.15-10.607A3.75 3.75 0 0 0 12 2.25Z"
      clipRule="evenodd"
    />
    <path
      fill="#F7A600"
      fillRule="evenodd"
      d="M13.219 12.409a.75.75 0 0 1 .532.917l-.087.33.781.207a.75.75 0 1 1-.385 1.45l-1.5-.398-.006-.002-.006-.002-.697-.185a.705.705 0 0 0-.361 1.362l1.405.374a2.204 2.204 0 0 1-1.109 4.267l-.087.33a.75.75 0 0 1-1.45-.385l.087-.33-.78-.207a.75.75 0 1 1 .384-1.45l2.21.586a.705.705 0 0 0 .36-1.362l-1.405-.373a2.205 2.205 0 0 1 1.109-4.267l.087-.33a.75.75 0 0 1 .918-.532ZM21 16.249a.75.75 0 0 1 .75.75v1.25H23a.75.75 0 0 1 0 1.5h-1.25V21a.75.75 0 1 1-1.5 0v-1.25H19a.75.75 0 1 1 0-1.5h1.25V17a.75.75 0 0 1 .75-.75Z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgTwoColorInviteFriends;
